import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GameContextType {
  hintCount: number;
  setHintCount: (count: number) => void;
}

const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [hintCount, setHintCount] = useState(0);

  return (
    <GameContext.Provider value={{ hintCount, setHintCount }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGameContext = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGameContext must be used within a GameProvider');
  }
  return context;
}; 